import Vue from 'vue'
import App from './App.vue'


//测试环境
// Vue.prototype.$p_url = 'http://192.168.31.164:8003'; //主项目 CC
// Vue.prototype.$p_url_shop = 'http://192.168.31.163:8081'; //商城
// Vue.prototype.$p_url_Developers = 'http://192.168.31.163:8115/system/api'; //开发者平台 CCs

//正式环境
Vue.prototype.$p_url = 'https://appapi.qiuitoy.com'; //主项目
Vue.prototype.$p_url_shop = 'https://shopapi.qiuitoy.com'; //商城
Vue.prototype.$p_url_Developers = 'https://openapi.qiuitoy.com/system/api'; //开发者平台


//全局参数
Vue.prototype.$p_domainName = 'https://spread.qiuitoy.com'; //域名
Vue.prototype.$p_urlImage = 'https://accelerate.qiuitoy.com/'; //图片URL
Vue.prototype.$p_urlScheme = 'xl://qiui:1715/'; //打开帖子详情的urlScheme
Vue.prototype.$p_urlHead = 'https://accelerate.qiuitoy.com/image/avatars/head.png'; //默认头像地址
Vue.prototype.$p_languages = ["en", "zh", "zh-CN"]; //支持的语言种类
Vue.prototype.$p_defaultLanguage = 'en'; //默认语言
Vue.prototype.$p_QIUI_API_AndroidUrl = 'https://github.com/ZouZLong/QIUI-API'; //开放平台Android的Github地址
Vue.prototype.$p_QIUI_API_IosUrl = 'https://github.com/GZguanshiwei/QIUIAPI'; //开放平台IOS的Github地址



//粒子动态库
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

//多语言
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: 'en', // 默认语言
	messages: {
		'zh': require('./language/zh.json'), // 中文语言包
		'zh-CN': require('./language/zh.json'),
		'en': require('./language/en.json'), // 英文语言包
		// 添加其他语言包
	},
});

// index.js中导入
// 0.导入路由
import VueRouter from 'vue-router'
// 使用vue的插件，都需要调用Vue.use()
Vue.use(VueRouter)


// 1.导入组件
//测试用的页面
import test from '@/share/Test.vue'
import home from '@/Home.vue'
//分享页面
import community from '@/share/Community.vue' //社区分享           //帖子id/帖子用户id/分享者id
import communityToys from '@/share/CommunityToys.vue' //玩具分享  //帖子id/帖子用户id
import commodity from '@/share/Commodity.vue' //商品详情         //商品id
import register from '@/share/Register.vue' //注册页面           
import download from '@/share/Download.vue' //下载页面
import download01 from '@/share/Download01.vue' //下载页面
import VoiceRoom from '@/share/VoiceRoom.vue' //直播间的分享页面
//入库页面
import WarehouseHome from '@/page/warehouse/WarehouseHome.vue' //入库查询页面
import WarehouseCare from '@/page/warehouse/WarehouseCare.vue' //入库操作卡 国外卡
import WarehouseCare_domestic from '@/page/warehouse/WarehouseCare_domestic.vue' //入库操作卡 国内卡
//风控页面
import WindControlLog from '@/page/wind_control/WindControlLog.vue' //风控登录页面
import WindControlHome from '@/page/wind_control/WindControlHome.vue' //风控首页
import WindControlInfo from '@/page/wind_control/WindControlInfo.vue' //风控详情 Android
import WindControlInfo01 from '@/page/wind_control/WindControlInfo01.vue' //风控详情 IOS
import WindControlBlackList from '@/page/wind_control/WindControlBlackList.vue' //封禁设备详情
import WindControlBanList from '@/page/wind_control/WindControlBanList.vue' //封禁账号详情
import WindControlIp from '@/page/wind_control/WindControlIp.vue' //封禁IP详情
import WhitelistList from '@/page/wind_control/WhitelistList.vue' //白名单列表
import WindControlHome_Admin from '@/page/wind_control/WindControlHome_Admin.vue' //管理员
import OperationLog from '@/page/wind_control/OperationLog.vue' //操作日志
//售后页面
import AfterSalesLog from '@/page/after_sales/AfterSalesLog.vue' //售后登录页面
import AfterSalesHome from '@/page/after_sales/AfterSalesHome.vue' //售后首页
import AfterSalesInfo from '@/page/after_sales/AfterSalesInfo.vue' //售后详情
import AfterSalesAdd from '@/page/after_sales/AfterSalesAdd.vue' //添加售后
//实名认证
import RealNameHome from '@/page/real_name/RealNameHome.vue' //实名认证首页
import BankCardHome from '@/page/real_name/BankCardHome.vue' //银行卡认证首页
import BankCardHomeInfo from '@/page/real_name/BankCardHomeInfo.vue' //银行卡认证详情
import WithdrawalHome from '@/page/real_name/WithdrawalHome.vue' //提现申请首页
import WithdrawalHomeInfo from '@/page/real_name/WithdrawalHomeInfo.vue' //提现详情
import VoiceRoomManagement from '@/page/real_name/VoiceRoomManagement.vue' //语音房管理
//Stripe支付
import StripeLogin from '@/page/stripe/StripeLogin.vue' //支付登录
import StripeHome from '@/page/stripe/StripeHome.vue' //支付列表
import StripeSuccess from '@/page/stripe/StripeSuccess.vue' //支付成功
import StripeFail from '@/page/stripe/StripeFail.vue' //支付失败
//H5页面
import AmapH5 from '@/page/h5/AmapH5.vue' //高德地图
import WzMapH5 from '@/page/h5/WzMapH5.vue' //维智地图
import PulseBird from '@/page/h5/PulseBird.vue' //脉冲鸟
import ShockGenMetal from '@/page/h5/ShockGenMetal.vue' //脉冲鸟
import Masturbator from '@/page/h5/Masturbator.vue' //飞机杯
import AnalPlug3 from '@/page/h5/AnalPlug3.vue' //二代加密肛塞
//开发者平台
import DeveloperAgreement from '@/page/developers/page/DeveloperAgreement.vue' //开发者协议
import DevelopersLogin01 from '@/page/developers/DevelopersLogin01.vue' //开发者账号登录
import DevelopersRegister01 from '@/page/developers/DevelopersRegister01.vue' //开发者账号注册
import EnterpriseRealName from '@/page/developers/page/realname/EnterpriseRealName.vue' //企业实名认证
import PersonalRealName from '@/page/developers/page/realname/PersonalRealName.vue' //个人实名认证
import DevelopersHome from '@/page/developers/DevelopersHome.vue' //开发者账号首页
import FirstPage from '@/page/developers/page/FirstPage.vue' //开发者账号第一个页面
import DevicesHome from '@/page/developers/page/devices/DevicesHome.vue' //已入库设备
import ApiCallLogging from '@/page/developers/page/devices/ApiCallLogging.vue' //API调用记录
import Config4g from '@/page/developers/page/devices/Config4g.vue' //4G配置文件
import ErrorCode from '@/page/developers/equipment/current/ErrorCode.vue' //全部的错误码
import Equipment from '@/page/developers/equipment/Equipment.vue' //查看哪个设备的文档
import KeyBoxHome01 from '@/page/developers/equipment/keybox01/KeyBoxHome01.vue' //一代钥匙盒
import Gen3Home from '@/page/developers/equipment/gen3/Gen3Home.vue' //三代锁
import GenMetalHome from '@/page/developers/equipment/genmetal/GenMetalHome.vue' //金属锁
import ShockGenMetalHome from '@/page/developers/equipment/shockgenmetal/ShockGenMetalHome.vue' //震动金属锁
import Analplug2 from '@/page/developers/equipment/analplug2/Analplug2.vue' //二代肛塞
//其他页面
import gen3Country from '@/page/Gen3Country.vue' //三代锁支持购买的国家
import deleteAccount from '@/page/DeleteAccount.vue' //谷歌删除用户账号的地址
import QIUIPrivacyPolicy from '@/page/QIUIPrivacyPolicy.vue' //QIUI 隐私政策
import VipExchange from '@/page/VipExchange.vue' //VIP兑换
import SingleSummary from '@/share/SingleSummary.vue' //将其他的单页面的路径 汇总到这个页面
import Home from '@/page/Home.vue' //整个系统的首页
import Login from '@/page/Login.vue' //整个系统的登录页面



// 2.创建路由规则
const routes = [{
		//开发者账号登录
		path: '/DevelopersLogin',
		name: 'DevelopersLogin',
		component: DevelopersLogin01,
		meta: {
			title: '登录'
		}
	}, {
		//开发者账号注册
		path: '/DevelopersRegister',
		name: 'DevelopersRegister',
		component: DevelopersRegister01,
		meta: {
			title: '注册'
		}
	}, {
		//开发者协议
		path: '/DeveloperAgreement',
		name: 'DeveloperAgreement',
		component: DeveloperAgreement,
		meta: {
			title: '开发者协议'
		}
	}, {
		//开发者账号首页
		path: '/DevelopersHome',
		name: 'DevelopersHome',
		component: DevelopersHome,
		meta: {
			title: '首页'
		},
		children: [ //里面的子路由
			{
				path: '/FirstPage',
				component: FirstPage,
				meta: {
					title: '首页'
				}
			}, {
				path: '/DevicesHome',
				component: DevicesHome,
				meta: {
					title: '已入库设备'
				}
			}, {
				path: '/ApiCallLogging',
				component: ApiCallLogging,
				meta: {
					title: 'API调用记录'
				}
			}, {
				path: '/Config4g',
				component: Config4g,
				meta: {
					title: '4G配置'
				}
			}, {
				path: '/Equipment',
				component: Equipment,
				meta: {
					title: '设备列表'
				}
			},
		]
	}, {
		//系统的登录
		path: '/Login1715',
		name: 'Login',
		component: Login,
		meta: {
			title: '登录'
		}
	}, {
		//系统的首页
		path: '/Home',
		name: 'Home',
		component: Home,
		meta: {
			title: '首页'
		},
		children: [ //里面的子路由
			{
				path: '/AfterSalesHome',
				component: AfterSalesHome,
				meta: {
					title: 'QIUI售后首页'
				}
			}, {
				path: '/WindControlHome',
				component: WindControlHome,
				meta: {
					title: 'QIUI风控首页',
					keepAlive: true // 使用 meta 字段指定需要缓存的组件
				},
			}, {
				path: '/WarehouseHome',
				name: 'WarehouseHome',
				component: WarehouseHome,
				meta: {
					title: '入库查询'
				}
			}, {
				path: '/RealNameHome',
				name: 'RealNameHome',
				component: RealNameHome,
				meta: {
					title: '实名认证'
				}
			}, {
				path: '/BankCardHome',
				name: 'BankCardHome',
				component: BankCardHome,
				meta: {
					title: '银行卡认证'
				}
			}, {
				path: '/WithdrawalHome',
				name: 'WithdrawalHome',
				component: WithdrawalHome,
				meta: {
					title: '提现申请'
				}
			}, {
				path: '/VoiceRoomManagement',
				name: 'VoiceRoomManagement',
				component: VoiceRoomManagement,
				meta: {
					title: '语音房管理'
				}
			}, {
				path: '/SingleSummary',
				name: 'SingleSummary',
				component: SingleSummary,
				meta: {
					title: '单页面汇总'
				}
			}, {
				path: '/WindControlHome_Admin',
				component: WindControlHome_Admin,
				meta: {
					title: '管理员'
				}
			}, {
				path: '/OperationLog',
				component: OperationLog,
				meta: {
					title: '操作日志'
				}
			},

		]
	}, {
		//测试
		path: '/test',
		name: 'test',
		component: test,
		meta: {
			title: '测试头部'
		}
	}, {
		//社区分享
		path: '/community/:topicId/:userId',
		name: 'community',
		component: community,
		meta: {
			title: 'QIUI'
		}
	}, {
		//社区分享
		path: '/community/:topicId/:userId/:shareId',
		name: 'community',
		component: community,
		meta: {
			title: 'QIUI'
		}
	}, {
		//玩具分享
		path: '/communityToys/:param1/:param2',
		name: 'communityToys',
		component: communityToys,
		meta: {
			title: 'QIUI'
		}
	}, {
		//商品详情
		path: '/commodity/:pid',
		name: 'commodity',
		component: commodity,
		meta: {
			title: 'QIUI'
		}
	}, {
		//直播间的分享
		path: '/VoiceRoom/:image/:name',
		name: 'VoiceRoom',
		component: VoiceRoom,
		meta: {
			title: 'QIUI'
		}
	}, {
		//注册
		path: '/register',
		name: 'register',
		component: register,
		meta: {
			title: 'QIUI'
		}
	}, {
		//下载
		path: '/download',
		name: 'download',
		component: download,
		meta: {
			title: 'QIUI'
		}
	}, {
		//下载 第二版 从官网的文件下载下来转换成vue2的代码
		path: '/download01',
		name: 'download01',
		component: download01,
		meta: {
			title: 'QIUI'
		}
	}, {
		//三代锁支持购买的国家
		path: '/gen3Country',
		name: 'gen3Country',
		component: gen3Country,
		meta: {
			title: 'QIUI'
		}
	}, {
		//谷歌删除账号网址
		path: '/deleteAccount',
		component: deleteAccount,
		meta: {
			title: 'QIUI'
		}
	}, {
		path: '/WarehouseCare/:iccid/:mac',
		name: 'WarehouseCare',
		component: WarehouseCare,
		meta: {
			title: '入库卡操作(国外)'
		}
	}, {
		path: '/WarehouseCare_domestic/:iccid/:mac',
		name: 'WarehouseCare_domestic',
		component: WarehouseCare_domestic,
		meta: {
			title: '入库卡操作(国内)'
		}
	}, {
		path: '/QIUIPrivacyPolicy',
		component: QIUIPrivacyPolicy,
		meta: {
			title: '隐私政策'
		}
	}, {
		path: '/VipExchange',
		component: VipExchange,
		meta: {
			title: 'VIP兑换'
		}
	}, {
		path: '/WindControlLog',
		component: WindControlLog,
		meta: {
			title: 'QIUI风控登录'
		}
	}, {
		path: '/WindControlInfo',
		component: WindControlInfo,
		meta: {
			title: 'QIUI风控详情'
		}
	}, {
		path: '/WindControlInfo01',
		component: WindControlInfo01,
		meta: {
			title: 'QIUI风控详情'
		}
	}, {
		path: '/WindControlBlackList',
		component: WindControlBlackList,
		meta: {
			title: 'QIUI封禁设备'
		}
	}, {
		path: '/WindControlBanList',
		component: WindControlBanList,
		meta: {
			title: 'QIUI封禁账号'
		}
	}, {
		path: '/AfterSalesLog',
		component: AfterSalesLog,
		meta: {
			title: 'QIUI售后登录'
		}
	}, {
		path: '/AfterSalesInfo',
		component: AfterSalesInfo,
		meta: {
			title: 'QIUI售后详情'
		}
	}, {
		path: '/AmapH5',
		component: AmapH5,
		meta: {
			title: '高德地图'
		}
	}, {
		path: '/WzMapH5',
		component: WzMapH5,
		meta: {
			title: '维智地图'
		}
	}, {
		path: '/WindControlIp',
		component: WindControlIp,
		meta: {
			title: 'IP封禁'
		}
	}, {
		path: '/WhitelistList',
		component: WhitelistList,
		meta: {
			title: '白名单'
		}
	}, {
		path: '/AfterSalesAdd',
		component: AfterSalesAdd,
		meta: {
			title: '添加售后'
		}
	}, {
		path: '/BankCardHomeInfo',
		component: BankCardHomeInfo,
		meta: {
			title: '银行卡认证详情'
		}
	}, {
		path: '/StripeHome',
		component: StripeHome,
		meta: {
			title: '支付'
		}
	}, {
		path: '/StripeSuccess',
		component: StripeSuccess,
		meta: {
			title: '支付成功'
		}
	}, {
		path: '/StripeFail',
		component: StripeFail,
		meta: {
			title: '支付失败'
		}
	}, {
		path: '/StripeLogin',
		component: StripeLogin,
		meta: {
			title: '支付登录'
		}
	}, {
		path: '/WithdrawalHomeInfo',
		component: WithdrawalHomeInfo,
		meta: {
			title: '提现详情'
		}
	}, {
		path: '/KeyBoxHome01',
		component: KeyBoxHome01,
		meta: {
			title: '一代钥匙盒'
		}
	}, {
		path: '/Gen3Home',
		component: Gen3Home,
		meta: {
			title: '三代锁'
		}
	}, {
		path: '/GenMetalHome',
		component: GenMetalHome,
		meta: {
			title: '金属锁'
		}
	}, {
		path: '/ShockGenMetalHome',
		component: ShockGenMetalHome,
		meta: {
			title: '震动金属锁'
		}
	}, {
		path: '/Analplug2',
		component: Analplug2,
		meta: {
			title: '二代肛塞'
		}
	}, {
		path: '/EnterpriseRealName',
		component: EnterpriseRealName,
		meta: {
			title: '企业认证'
		}
	}, {
		path: '/PersonalRealName',
		component: PersonalRealName,
		meta: {
			title: '个人认证'
		}
	}, {
		path: '/PulseBird/:toyId/:receiverID/:uuid',
		component: PulseBird,
		meta: {
			title: '脉冲鸟'
		}
	}, {
		path: '/ShockGenMetal/:toyId/:receiverID/:uuid',
		component: ShockGenMetal,
		meta: {
			title: '震动金属锁'
		}
	}, {
		path: '/Masturbator/:toyId/:receiverID/:uuid',
		component: Masturbator,
		meta: {
			title: '飞机杯'
		}
	}, {
		path: '/AnalPlug3/:toyId/:receiverID/:uuid',
		component: AnalPlug3,
		meta: {
			title: '肛塞'
		}
	}, {
		path: '/ErrorCode',
		component: ErrorCode,
		meta: {
			title: '错误码'
		}
	},











]


// 3.创建路由对象
const router = new VueRouter({
	routes, // (缩写) 相当于 routes: routes
	mode: 'history', //默认是hash模式
})

//这行代码的目的是为了在生产环境中关闭 Vue 的开发版本提示，以保持控制台的清洁。
//在开发环境中，Vue 会继续提醒你使用开发版本，以便你能够更容易地进行调试
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	// 在路由切换前修改页面标题
	document.title = to.meta.title || 'QIUI';
	next();
});

// 4.挂载路由到根组件
new Vue({
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')



//外网域名：https://spread.qiuitoy.com/